import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { AppService } from 'src/app/app.service';
import { InstructionService } from 'src/app/modules/core/services/instruction/instruction.service';
import { isInIframe } from 'src/app/modules/shared/isInIframe';

@Component({
    selector: 'app-instruction-by-alias',
    templateUrl: './instruction-by-alias.component.html',
    styleUrls: ['./instruction-by-alias.component.scss']
})
export class InstructionByAliasComponent implements OnInit, OnDestroy {

    @Output() instructionEmitter: EventEmitter<any> = new EventEmitter();

    private destroy$: Subject<void> = new Subject();

    constructor(
        private instructions: InstructionService,
        private route: ActivatedRoute,
        private readonly appService: AppService) { }

    ngOnInit() {
        this.route.params
            .pipe(takeUntil(this.destroy$))
            .subscribe(params => {
                this.handleRouteParameterChange(params);
            });
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    private handleRouteParameterChange(params: Params) {
        this.instructionEmitter.emit(undefined);

        this.instructions.getInstructionByAlias(`${params.id}/${params.year}`)
            .subscribe(result => {
                result.data['inIframe'] = isInIframe();
                result.data['openedFrom'] = this.appService.openedFrom();
                this.instructionEmitter.emit(result);
            });
    }
}
